import React from "react";
import { Wrapper } from "../Panel";
const FontStyles = ((props: any) => {
    const { value, open, key, label, placeholder, type } = props;
    return (
        <Wrapper key={key}>
            <p className="panel-label">
                {label}
            </p>
            <p
                className="font-medium rounded-md cursor-pointer flex items-center justify-center"
                style={{
                    color: "#0466C8",
                    backgroundColor: "rgba(4, 102, 200, 0.1)",
                    height: "28px",
                    width: "170px",
                    padding: "5px"
                }}
                data-test-id={`${type}-${label}`}
                onClick={((e:any) => {e.stopPropagation(); open() })}
            >
                <div className="flex h-full items-center justify-between">
                    <p>{placeholder}</p>
                </div>
            </p>
        </Wrapper>
    )
})
export default FontStyles;